// Contas do app do agenciador (puras; testadas em test/app/agenciador.test.js):
// a situação de cada carga que ele agenciou e a do agenciamento dela.

// A carga: a carregar, no caminhão ou entregue.
export function situacaoDaCarga(f, hoje) {
  if (f.data_descarga) return { tipo: 'entregue', texto: 'Entregue', tom: 'ok' };
  if (f.data_carregamento > hoje) return { tipo: 'a_carregar', texto: 'A carregar', tom: '' };
  return { tipo: 'no_caminhao', texto: 'No caminhão', tom: 'info' };
}

// O agenciamento da carga: já entrou num acerto, está liberado para o
// próximo (o cliente pagou o adiantamento, ou a carga não tem adiantamento)
// ou espera o adiantamento do cliente (mesma regra da prévia do acerto).
export function situacaoDoAgenciamento(f, { lancamentos = [], acertos = [] } = {}) {
  const valor = Number(f.agenciamento_valor) || 0;
  if (f.importacao_id) return { valor, tipo: 'importada', texto: 'acertado nos programas antigos' };
  if (!(valor > 0)) return { valor: 0, tipo: 'sem', texto: 'sem agenciamento lançado' };
  const credito = lancamentos.find((l) => !l.deleted_at && l.tipo === 'credito' && l.subtipo === 'agenciamento' && l.frete_id === f.id);
  if (credito?.acerto_id) {
    const a = acertos.find((x) => x.id === credito.acerto_id);
    if (!a) return { valor, tipo: 'acertado', texto: 'acertado' };
    return {
      valor,
      tipo: 'acertado',
      texto: `no acerto nº ${a.numero}/${a.ano}${a.status === 'fechado' ? ' (ainda não pago)' : ''}`,
    };
  }
  const liberado = Boolean(f.adto_recebido_em) || !(Number(f.adto_valor) > 0);
  return liberado
    ? { valor, tipo: 'liberado', texto: 'entra no próximo acerto' }
    : { valor, tipo: 'esperando', texto: 'espera o adiantamento do cliente' };
}

// As cargas dele: em andamento (ainda sem descarga, da mais antiga) e as
// entregues (da descarga mais nova).
export function cargasDoAgenciador(fretes) {
  const vivas = (fretes ?? []).filter((f) => !f.deleted_at);
  const texto = (v) => String(v ?? '');
  return {
    andamento: vivas.filter((f) => !f.data_descarga)
      .sort((a, b) => texto(a.data_carregamento).localeCompare(texto(b.data_carregamento))),
    entregues: vivas.filter((f) => f.data_descarga)
      .sort((a, b) => texto(b.data_descarga).localeCompare(texto(a.data_descarga))
        || texto(b.entregue_em).localeCompare(texto(a.entregue_em))),
  };
}
